import React from 'react';

const ColorSelector = ({
    selectedPart,
    selectedColor, // Valore (ID) selezionato corrente
    handleColorSelect,
    disabledParts,
    allOptions
}) => {
    if (!selectedPart) return null;

    // Normalizziamo le opzioni (aggiungiamo "Nessuno" se non è required)
    let items = selectedPart.values || [];
    const isRequired = selectedPart.required === 1 || selectedPart.required === true || selectedPart.required === "1";

    // Aggiungi opzione "Nessuno" se necessario
    if (!isRequired && !items.find(i => String(i.id) === "none")) {
        items = [{
            id: "none",
            label: "Nessuno",
            name: "Nessuno",
            image: null,
            miniature: null,
            is_default: 0 
        }, ...items];
    }

    const isLocked = disabledParts[selectedPart.name] && disabledParts[selectedPart.name].length > 0;

    // Helper: formatta i nomi delle parti bloccanti con il loro indice (n/MAX)
    const formatBlockerNames = (blockerNames) => {
        if (!allOptions || allOptions.length === 0) return blockerNames.join(', ');
        const total = allOptions.length;
        return blockerNames.map(name => {
            const idx = allOptions.findIndex(o => o.name === name);
            if (idx !== -1) {
                return `${name} (${idx + 1}/${total})`;
            }
            return name;
        }).join(', ');
    };
    
    // Stile griglia
    const gridStyle = {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
        gap: '15px',
        padding: '10px',
        width: '100%',
        overflowY: 'auto',
        maxHeight: '100%'
    };

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Messaggio se bloccato */}
            {isLocked && (
                <div className="alert alert-warning text-center m-3">
                    <i className="fas fa-lock me-2"></i>
                    Opzione bloccata. Attiva prima: <strong>{formatBlockerNames(disabledParts[selectedPart.name])}</strong>
                </div>
            )}

            {!isLocked && (
                <div style={gridStyle}>
                    {items.map((item) => {
                        // *** LOGICA DI SELEZIONE MODIFICATA ***
                        // 1. Se c'è un selectedColor valido, controlla se corrisponde a questo item.
                        // 2. Se selectedColor è vuoto/null (appena aperto), controlla se questo item è il default.
                        
                        const hasSelection = selectedColor !== undefined && selectedColor !== null && selectedColor !== "undefined" && selectedColor !== "";
                        
                        const isSelected = hasSelection 
                            ? String(selectedColor) === String(item.id)
                            : (item.is_default == 1 || item.is_default === true);

                        // Gestione immagine (CDN o placeholder)
                        let imgUrl = "/placeholder.png"; // Fallback
                        if (item.id === "none") {
                            // SVG per "Nessuno" - Icona divieto stilizzata
                            imgUrl = "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120'><rect width='120' height='120' fill='transparent'/><circle cx='60' cy='60' r='45' stroke='%23ccc' stroke-width='8' fill='none'/><line x1='30' y1='30' x2='90' y2='90' stroke='%23ccc' stroke-width='8'/></svg>";
                        } else if (item.miniature && item.miniature !== "null") {
                            imgUrl = item.miniature.startsWith('http') ? item.miniature : `https://cdn.psicopaticiservice.com/${item.miniature}`;
                        } else if (item.image && item.image !== "null") {
                             imgUrl = item.image.startsWith('http') ? item.image : `https://cdn.psicopaticiservice.com/${item.image}`;
                        } else if (item.texture && item.texture !== "null") {
                             imgUrl = item.texture.startsWith('http') ? item.texture : `https://cdn.psicopaticiservice.com/${item.texture}`;
                        }

                        return (
                            <div
                                key={item.id}
                                onClick={() => handleColorSelect(selectedPart.id, String(item.id))}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    opacity: isLocked ? 0.5 : 1
                                }}
                            >
                                <div
                                    style={{
                                        width: '80px',
                                        height: '80px',
                                        borderRadius: '50%',
                                        // *** COLORE VERDE SE SELEZIONATO ***
                                        border: isSelected ? '4px solid #00c853' : '1px solid #ddd',
                                        padding: '2px',
                                        overflow: 'hidden',
                                        backgroundColor: '#fff',
                                        // *** OMBRA VERDE SE SELEZIONATO ***
                                        boxShadow: isSelected ? '0 4px 12px rgba(0, 200, 83, 0.4)' : 'none',
                                        transition: 'all 0.2s ease',
                                        transform: isSelected ? 'scale(1.05)' : 'scale(1)'
                                    }}
                                >
                                    <img
                                        src={imgUrl}
                                        alt={item.label || item.name}
                                        style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                                    />
                                </div>
                                <span style={{ 
                                    marginTop: '8px', 
                                    fontSize: '12px', 
                                    textAlign: 'center',
                                    // *** TESTO VERDE E GRASSETTO SE SELEZIONATO ***
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    color: isSelected ? '#00c853' : '#333',
                                    maxWidth: '90px',
                                    lineHeight: '1.2'
                                }}>
                                    {item.label || item.name}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ColorSelector;